<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Copyright"><span> </span></p>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing"><span> </span></p>
</div></div>
<div style="page-break-before: always;"></div>
<div class="P_Normal__And__Centre_Alignment__And__Page_Break">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><div style="page-break-before: always;"></div>
<p class="P_Normal__And__Centre_Alignment__And__Line_Spacing__And__Page_Break"><span><span style=" font-family: 'Poor Richard'; font-size: 1.50em;">COPYRIGHTS</span></span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing"><span> </span></p>
</div></div>
<p class="P_CopyrightPage">“Slay” copyright © 2023 by Esther M. Friesner</p>
<p class="P_CopyrightPage">“Avarice and Vengeance” copyright © 2023 by Madeline Dau</p>
<p class="P_CopyrightPage">“The Princess Network” copyright © 2023 by Niall Spain</p>
<p class="P_CopyrightPage">“Cold Fire of Manhattan” copyright © 2023 by Russell Hugh </p>
<p class="P_CopyrightPage">McConnell</p>
<p class="P_CopyrightPage">“Duck, Duck, Dragon” copyright © 2023 by Grace Eliza Ashton</p>
<p class="P_CopyrightPage">“Sheep Rarely Wear Gold” copyright © 2023 by Mike Jack Stoumbos</p>
<p class="P_CopyrightPage">“The Exposé” copyright © 2023 by Paul D. Smith</p>
<p class="P_CopyrightPage">“Lord Bai and the Magic Pirate” copyright © 2023 by Jean Marie Ward</p>
<p class="P_CopyrightPage">“Tatsu: Cryo Five” copyright © 2023 by Gerald Brandt</p>
<p class="P_CopyrightPage">“A King Arthur Dragon in Space Station 23’s Court” copyright © 2023 by Jeanne Cook &amp; Vicki Küng</p>
<p class="P_CopyrightPage">“Migration Season” copyright © 2023 by Larry Ivkovich</p>
<p class="P_CopyrightPage">“Bone and Blood” copyright © 2023 by Barbara Campbell</p>
<p class="P_CopyrightPage">“The Breeding Habits of Dragons” copyright © 2023 by Journey Sloane</p>
<p class="P_CopyrightPage">“Gods in Chains” copyright © 2023 by Em McDermott</p>
<p class="P_CopyrightPage">“The Left Hand of Giordino” copyright © 2023 by Auston Habershaw</p>
<div class="P_Normal">
<div class="B_Box2" style="display:inline-block;"><p class="P_Normal__And__Line_Spacing"><span style=" font-size: 0.67em;">“Reenactment” copyright © 2023 by David B. Coe</span></p>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0005.vue?19392475